import { Controller, useFormContext } from 'react-hook-form';
import { StyledTextField } from '../../CalculusCard';
import { GridApiPremium } from '@mui/x-data-grid-premium';
import { MutableRefObject } from 'react';
import { BulkEditPricesSchema, PriceItemSchema } from './bulkEditPricesSchema';

interface Props {
  fieldName: string;
  mgSupplierItemId: number;
  apiRef: MutableRefObject<GridApiPremium | null>;
  disabled: boolean;
  handleKeyDown: (event: React.KeyboardEvent) => void;
}

export function SalesPriceTextField({
  fieldName,
  mgSupplierItemId,
  apiRef,
  disabled,
  handleKeyDown,
}: Props) {
  const {
    control,
    formState: { errors },
  } = useFormContext<BulkEditPricesSchema<PriceItemSchema>>();

  const error = errors.items?.[mgSupplierItemId]?.salesPrice;

  return (
    <Controller
      name={`items.${mgSupplierItemId}.${fieldName}`}
      control={control}
      render={({ field }) => {
        return (
          <StyledTextField
            value={field.value ?? ''}
            error={!!error}
            size="small"
            disabled={disabled}
            onKeyDown={handleKeyDown}
            onChange={(e) => {
              field.onChange(e.target.value);

              apiRef?.current?.setEditCellValue({
                id: mgSupplierItemId,
                field: 'newPrice',
                value: e.target.value,
              });
            }}
          />
        );
      }}
    />
  );
}
